import { useEffect, useRef } from "react";

interface Params {
  durationSeconds: number | null;
  onDone: () => void;
}

const useSetupWait = ({ durationSeconds, onDone }: Params) => {
  // state
  const onDoneRef = useRef(onDone);

  // effects
  // The handler is rebuilt on every render, so the timer reads the latest one instead of restarting.
  useEffect(() => {
    onDoneRef.current = onDone;
  }, [onDone]);

  // Times the wait the backend asked for and hands off to the switch when it ends.
  useEffect(() => {
    if (durationSeconds === null) return undefined;
    const finisher = window.setTimeout(() => onDoneRef.current(), durationSeconds * 1000);
    return () => window.clearTimeout(finisher);
  }, [durationSeconds]);
};

export default useSetupWait;
